/**
 * One-shot notes generation (client-only pivot, Phase 4).
 *
 * The AI chat was deliberately removed from the product — this is the
 * whole AI-notes surface: transcript → meeting minutes (structured,
 * citation-checked) → markdown → TipTap document. Runs in the browser
 * on the user's key; edits afterwards are manual.
 */
import {
  generateMeetingMinutes,
  type GenerateNotesOptions,
} from "@/lib/openai/generate-notes";
import { renderNotesToMarkdown } from "@/lib/notes/render-markdown";
import {
  markdownToNotesDocument,
  type NotesDocumentJson,
} from "@/lib/notes/tiptap-document";
import type { TranscriptSegment } from "@/lib/types/domain";

export async function generateNotesFromTranscript(
  segments: TranscriptSegment[],
  options: GenerateNotesOptions = {},
): Promise<NotesDocumentJson> {
  // Inline [seg-N] prefixes make the model's citations verifiable — the IDs
  // it emits are checked against this set after parsing.
  const minutes = await generateMeetingMinutes(
    segments.map((s) => `[${s.id}] ${s.text}`).join("\n"),
    segments.map((s) => s.id),
    options,
  );

  return markdownToNotesDocument(renderNotesToMarkdown(minutes));
}
